"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgUsers(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm15.95435 12.34247-1.01386-2.24518a.43416.43416 0 0 0 -.22534-.21906l-1.58942-.82147h-.11267a2.56326 2.56326 0 0 1 -1.512.563 2.16049 2.16049 0 0 1 -.68427-.12189l1.033 2.2873.01935.04278.0152.04444a1.74584 1.74584 0 0 1 .01477 1.12725h3.60473a.51727.51727 0 0 0 .45057-.219.58456.58456 0 0 0 -.00006-.43817zm-4.46217-3.55769a2.23542 2.23542 0 0 0 2.02787-2.39239c0-1.82278-.90124-2.39239-2.02787-2.39239s-2.02781.56961-2.02781 2.39239a2.23541 2.23541 0 0 0 2.02781 2.39239zm-.55382 3.412-1.23924-2.74423a.53048.53048 0 0 0 -.27542-.26778l-1.94265-1.004h-.13774a3.13342 3.13342 0 0 1 -1.84812.68811 3.19591 3.19591 0 0 1 -1.86964-.68811h-.13773l-1.92777 1.004a.53052.53052 0 0 0 -.27542.26778l-1.23924 2.74422a.71429.71429 0 0 0 0 .53553.63225.63225 0 0 0 .55072.2677h9.7915a.63234.63234 0 0 0 .55075-.2677.7142.7142 0 0 0 0-.53553zm-5.454-4.34849a2.73227 2.73227 0 0 0 2.47864-2.92415c0-2.22793-1.10157-2.92414-2.47861-2.92414s-2.47852.69621-2.47852 2.92414a2.73226 2.73226 0 0 0 2.47852 2.92414z' })));
}
exports.default = SvgUsers;
